export default __webpack_public_path__ + "static/media/logo.82b36dcd.png";